var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.pageItem.homeCardTitleUseYn === 'Y')?_c('div',{staticClass:"portlet_tit"},[_c('h3',{staticClass:"tt_tit"},[_vm._v("\n      "+_vm._s(_vm.pageItem.homeCardName)+"\n    ")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }